import { render } from "./ConcessionaireView.vue?vue&type=template&id=502345fa&scoped=true"
import script from "./ConcessionaireView.vue?vue&type=script&lang=js"
export * from "./ConcessionaireView.vue?vue&type=script&lang=js"

import "./ConcessionaireView.vue?vue&type=style&index=0&id=502345fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502345fa"]])

export default __exports__